<template>
  <div class="source-content-tabs">
    <div class="source-types">
      <button
        class="btn btn-link btn-sm tab-btn--outlined"
        :class="{
          active: selectedTab === 'templates',
        }"
        data-entity="producer-assets-showTemplates"
        data-test="producer-assets-templatesTab"
        @click="selectedTab = 'templates'"
      >
        Templates
      </button>

      <button
        class="btn btn-link btn-sm tab-btn--outlined"
        :class="{
          active: selectedTab === 'saved-graphics',
        }"
        data-entity="producer-assets-showSavedGraphics"
        data-test="producer-assets-savedGraphicsTab"
        @click="selectedTab = 'saved-graphics'"
      >
        <span class="icon icon-saved margin-right-xxs" />
        Saved Graphics
      </button>
    </div>

    <keep-alive>
      <component :is="currentTabComponent" />
    </keep-alive>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Graphics',
  data() {
    return {
      selectedTab: 'templates',
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.selectedTab) {
        case 'saved-graphics':
          return () => import('./SavedGraphics.vue');
        default:
          return () => import('./GraphicTemplates.vue');
      }
    },
  },
  created() {
    this.getGraphicsTags();
  },
  methods: {
    ...mapActions(['getGraphicsTags']),
  },
};
</script>
